/* eslint-disable @typescript-eslint/prefer-for-of */
import { useState } from 'react'
import { usePapaParse } from 'react-papaparse'

const parseDefaults = {
  skipEmptyLines: true,
  delimiter: '\t', // Force tab delimiter
  newline: '\n',
}

export function useCardInputPromptParser(onGenerated: (prompts: string[]) => void, isRepeat: boolean) {
  const { readString } = usePapaParse()
  const [textareaValue, setTextareaValue] = useState('')

  const handleTextareaChange = (value: string) => {
    setTextareaValue(value)
  }

  const handleCsvUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]

    if (!file) return

    const reader = new FileReader()

    reader.onload = () => {
      readString(reader.result as string, {
        ...parseDefaults,
        complete: results => {
          const rows = results.data as string[][]
          const prompts = rows
            .filter(row => row.length >= 1 && row[0]?.trim())
            .map(row => {
              const targetText = row[0].trim()
              const translation = row[1]?.trim()
              return translation ? `${targetText}\t${translation}` : targetText
            })

          onGenerated(prompts)
        },
      })
    }

    reader.readAsText(file)
  }

  const generateCardEntriesFromTextarea = () => {
    readString(textareaValue.trim(), {
      ...parseDefaults,
      complete: results => {
        const rows = results.data as string[][]

        if (isRepeat) {
          const rowsTransformet: string[][] = []

          for (let i = 0; i < rows.length; i++) {
            const row = rows[i]

            const targetText = row[0]
            const translation = row[1]

            rowsTransformet.push([targetText, translation])
          }

          setTextareaValue('')
          onGenerated(rowsTransformet.flat())
        } else {
          const promptFilteredRows = rows.filter(row => row.length && row[0]?.trim())
          const prompts = promptFilteredRows.map(row => row[0].trim())

          setTextareaValue('')
          onGenerated(prompts)
        }
      },
    })
  }

  return {
    textareaValue,
    setTextareaValue,
    handleTextareaChange,
    handleCsvUpload,
    generateCardEntriesFromTextarea,
  }
}
